import {
  generatePath,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";

import { getAnchor } from "@/api/endpoints/mentions";
import { FILTER } from "@/constants";
import PublicLayout from "@/containers/PublicLayout";
import { ROUTES } from "@/routes_new";
import { pageFromFeedIndex } from "@/utils";
import deleteNil from "@/utils/deleteNil";
import { stringifyQuery } from "@/utils/query-string";
import { useQuery } from "@tanstack/react-query";

const AnchorRedirect = () => {
  const { orgUuid, search_uuid, mention_uuid } = useParams<{
    orgUuid: string;
    search_uuid: string;
    mention_uuid: string;
  }>();
  const { pathname } = useLocation();

  const { data } = useQuery({
    queryKey: ["anchor", mention_uuid],
    queryFn: () => getAnchor(mention_uuid),
  });

  // Derived, not synced into state: a previous-value guard would never fire when
  // the query cache is already warm on the first render, leaving the spinner up
  // forever.
  let redirectTo: string | undefined;

  if (data?.ok) {
    if (data.status === 205) {
      const newOrgUuid = data.headers.get("x-new-organization-uuid");
      redirectTo = pathname.replace("/a/", `/a/${newOrgUuid}/`);
    } else {
      const response = data.data;

      if (response.feed_index === undefined) {
        throw new Error();
      }

      // generate the URL. pass the mention_uuid along as a hash
      const path = generatePath(ROUTES.MENTION_DETAIL_ORGID, {
        orgUuid,
        uuid: search_uuid,
      });
      redirectTo = `${path}?${stringifyQuery(
        deleteNil({
          [FILTER.PAGE]: pageFromFeedIndex(response.feed_index),
        })
      )}#${mention_uuid}`;
    }
  }

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  return (
    <PublicLayout>
      <div className="flex justify-center pt-5 mt-5">
        <div className="spinner-grow" />
      </div>
    </PublicLayout>
  );
};

export default AnchorRedirect;
